// ─────────────────────────────────────────────────────────────────────────────
// LUMIÈRE PRICING — single source of truth for the /pricing page (v3, from 1 Oct 2026).
// Edited by the practice manager. Rules that must never change:
//   • NO prices, "from" prices, ranges, packages or bundles on injectables or
//     any other prescription treatment (Australian advertising regulations).
//   • No discounts, offers, member rates or urgency wording.
//   • Courses are for non-prescription treatments only.
//   • Every price includes GST.
// ─────────────────────────────────────────────────────────────────────────────

export const CONSULTATION_COLUMNS = ["Duration", "Fee", "Deposit"];

export const CONSULTATIONS = [
  { name: "Skin consultation", sub: "Lizzie Stock, Skin & Cosmetic Nurse", prices: ["45 min", "$100", "$50"] },
  { name: "Physician consultation", sub: "Any physician, any concern", prices: ["45 min", "$250", "$100"] },
  { name: "Skin assessment", sub: "Dr Kiran Shahid", prices: ["45 min", "$250", "$100"], note: true },
  { name: "Hair assessment", sub: "Dr Kristy Truong · in person at Cottesloe", prices: ["45 min", "$250", "$100"] },
  { name: "Body and wellness assessment", sub: "Dr Anthony Chaffee", prices: ["45 min", "$250", "$100"] },
  { name: "Review", sub: "Existing patients", prices: ["15 min", "No charge", "—"] },
];

export const REGENERATIVE = {
  columns: ["Single", "Course of three"],
  rows: [
    { name: "Rejuran — full face", sub: "2 ml", prices: ["$895", "$2,450"] },
    { name: "Rejuran — eye", prices: ["$750", "$2,050"] },
    { name: "PRP or PRF — face or scalp", sub: "Injected", prices: ["$650", "$1,750"] },
    { name: "PRP with skin needling", sub: "Platelets needled in", prices: ["$699", "—"] },
    { name: "Skin needling", prices: ["$350", "$950"] },
    { name: "Booster or exosome add-on to skin needling", prices: ["+$100", "—"] },
  ],
};

export const THREADS = {
  columns: ["Price"],
  rows: [
    { name: "PDO mono threads", sub: "Per area · Dr Kristy Truong", prices: ["from $1,200"] },
    { name: "Thread lift", sub: "Per session, by area · quoted after a physician consultation", prices: ["$3,500–$4,800"] },
  ],
};

export const SKIN_LASER = {
  columns: ["Single", "Course of three"],
  rows: [
    { name: "Medical-grade peel", sub: "Signature", prices: ["$180", "$486"] },
    { name: "Advanced peel", sub: "Jessner, TCA or ZO", prices: ["$280", "$756"] },
    { name: "Laser facial", prices: ["$450", "$1,215"] },
    { name: "Neck or décolletage add-on", prices: ["$99", "—"] },
    { name: "Vascular spot treatment", prices: ["$250", "—"] },
    { name: "CO2 fractional resurfacing", sub: "Small area", prices: ["from $1,500", "—"] },
    { name: "RF microneedling (Morpheus8)", sub: "Indicative — confirmed once equipment is finalised", prices: ["$1,400", "$3,800"] },
    { name: "BBL photorejuvenation", sub: "Indicative — confirmed once equipment is finalised", prices: ["$550", "$1,500"] },
    { name: "LED facial", prices: ["$90", "$243"] },
    { name: "LED add-on to any treatment", prices: ["$60", "—"] },
  ],
};

export const MINOR_PROCEDURES = {
  columns: ["Price"],
  rows: [
    { name: "Skin tag or milia removal", sub: "Small or follow-up · bookable with Lizzie Stock", prices: ["from $150"] },
    { name: "Lesion removal — standard", sub: "After skin assessment", prices: ["$350"] },
    { name: "Lesion removal — large or multiple", sub: "After skin assessment · quoted per treatment plan", prices: ["from $500"] },
  ],
};

export const BODY = {
  columns: ["Per session", "Course"],
  rows: [
    { name: "EMSCULPT Neo — abdomen", sub: "Course of four", prices: ["$550", "$2,000"] },
    { name: "EMSCULPT Neo — buttocks", sub: "Course of four", prices: ["$550", "$2,000"] },
    { name: "EMSCULPT Neo — arms or calves", sub: "Course of four", prices: ["$550", "$2,000"] },
    { name: "Maintenance session", sub: "Within six months of a course", prices: ["$350", "—"] },
    { name: "Emsella pelvic floor", sub: "Course of five", prices: ["$220", "$1,200"] },
  ],
};
